import State from '../interfaces/states/AuthState';

import * as Const from '../constants';
import * as Http from '../interceptors/index';

const initState: State = {
  initLoading: false,
  isLoading: false,
  error: false,
  isAuth: false,
  token: Http.getToken(),
  user: null,
  isErrorMessage: false,
  refreshToken: Http.getRefreshToken(),
};

export default function auth (state: State = initState, action): State {
  switch (action.type) {
    case Const.AUTH_SUCCESS:
      return {
        ...state,
        initLoading: false,
        isLoading: false,
        error: false,
        isAuth: true,
        token: Http.getToken(),
        isErrorMessage: false,
      };

    case Const.AUTH_MOUNTED_SUCCESS:
      return {
        ...state,
        initLoading: false,
        isLoading: false,
        error: false,
        isAuth: true,
        user: action.payload,
        isErrorMessage: false,
      };

    case Const.AUTH_INIT:
      return {
        ...initState,
      };

    case Const.AUTH_FAIL:
      return {
        ...state,
        initLoading: false,
        error: true,
        isLoading: false,
        isAuth: false,
        isErrorMessage: true,
      };
    case Const.AUTH_LOADING:
      return {
        ...state,
        isLoading: true,
        initLoading: true,
        error: false,
        isAuth: false,
        isErrorMessage: false,
      };
    case Const.AUTH_SUCCESS_LOAD:
      return {
        ...state,
        isLoading: false,
        error: false,
        isAuth: true,
        isErrorMessage: false,
      };
    case Const.AUTH_EXIT:
      return {
        ...state,
        initLoading: false,
        token: '',
        refreshToken: '',
      };

    case Const.AUTH_ERROR_MESSAGE_INIT:
      return {
        ...state,
        isErrorMessage: false,
      };

    case Const.AUTH_REFRESH_TOKEN:
      return {
        ...state,
        initLoading: false,
        isLoading: false,
        error: false,
        isAuth: true,
        isErrorMessage: false,
        refreshToken: Http.getRefreshToken(),
      };

    default:
      return state;
  }
}
